<div class="popover-layer">
  <button class="backdrop" type="button" tabindex="-1" aria-label="Cerrar opciones" (click)="close()"></button>
  <span #arrow class="popover-arrow" aria-hidden="true"></span>
  <div #menu class="popover-options" role="menu" aria-label="Opciones">
    @for (group of popover().actions; track $index) {
      <div class="option-group" role="group" aria-label="Acciones">
        @for (action of group; track $index) {
          <button class="popover-option {{ action.styleClass }}" type="button" role="menuitem" [disabled]="action.disabled" (click)="selectOption(action)">
            @if (action.icon) {
              <span class="icon" aria-hidden="true" [style.mask-image]="'url(/icons/' + action.icon + '.svg)'" [style.-webkit-mask-image]="'url(/icons/' + action.icon + '.svg)'"></span>
            }
            <span>{{ action.label }}</span>
          </button>
        }
      </div>
    }
  </div>
</div>
